import React, { useState } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Icon } from 'components';
import { Row, Col, Button, Alert, Icon as AntIcon, Modal, Form, InputNumber } from 'antd';

import classes from '../styles/teacher/TeacherInfo.module.scss';
import { formatNumber } from 'utils/formatting';
import { Link } from 'react-router';
import { editTeacher } from 'data/teacher';
const FormItem = Form.Item;

const ComFeeModal = ({ teacher = {}, isOpen, setIsOpen, form, reload }) => {
  const { getFieldDecorator, getFieldsValue } = form;
  const [loading, setLoading] = useState(false);

  const onUpdateFee = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        try {
          setLoading(true);
          await editTeacher(teacher._id, { feePercentage: values.feePercentage });
          await reload();
          setIsOpen(false);
          setLoading(false);
        } catch (err) {
          alert(err);
          setLoading(false);
        }

        console.log('Received values of form: ', values);
      }
    });
  };
  return (
    <Modal
      title={'Commision Fee'}
      visible={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={[
        <Button key="back" size="large" onClick={() => setIsOpen(false)}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" size="large" loading={loading} onClick={onUpdateFee}>
          Save
        </Button>,
      ]}
    >
      <Form onSubmit={onUpdateFee}>
        <FormItem labelCol={{ span: 12 }} wrapperCol={{ span: 12 }} label="Commission Fee(%)" hasFeedback>
          {getFieldDecorator('feePercentage', {
            rules: [
              {
                required: true,
                type: 'number',
                message: 'Please input fee',
              },
            ],
            initialValue: teacher.feePercentage,
          })(<InputNumber />)}
        </FormItem>
      </Form>
    </Modal>
  );
};

export default Form.create()(ComFeeModal);
